import React from 'react';
import moment from 'moment';

import combinedShape from '../../img/combined-shape.svg';

class CmsFooter extends React.Component {
  render() {
    return (
      <footer className="cms-footer">
        <div className="cms-footer-footnote">
          <img src={combinedShape} className="cms-footer-logo" />
          <span className="cms-footer-copyright">Copyright &copy; Prospect Path {moment().format('Y')}</span>
        </div>
        <nav className="cms-footer-nav">
          <a href="https://info.prospectpath.com/terms/" className="cms-footer-nav-item">Terms</a>
          <a href="https://info.prospectpath.com/privacy-policy/" className="cms-footer-nav-item">Privacy Policy</a>
          <a href="http://support.prospectpath.com/" className="cms-footer-nav-item">Support</a>
          <a href="http://support.prospectpath.com/contact" className="cms-footer-nav-item">Contact</a>
        </nav>
      </footer>
    );
  }
}

export default CmsFooter;
